import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RegularPage from '@/components/templates/RegularPageLayout';

import { Card, CardHeader, CardContent } from '@mui/material';
import { useTypeSafeTranslation } from '@/i18n';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function SampleListPage() {
  const { t } = useTypeSafeTranslation();
  // 言語設定を取得する処理を入れておくことで、言語設定が変更されたときに再レンダリングされるようにしておく
  useSelector<RootState>((state) => state.main.persistent.language);

  return (
    <RegularPage title={t('pages.sampleList.title')}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', pb: 2 }}>
        <Button variant="contained" component={Link} to="/create-task">
          {t('pages.sampleList.createButton')}
        </Button>
      </Box>

      <Card>
        <CardHeader title={t('pages.sampleList.listHeader')} titleTypographyProps={{ variant: 'h6' }} />
        <CardContent sx={{ pt: 0 }}></CardContent>
      </Card>
    </RegularPage>
  );
}
